import React, { useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import IcomoonReact from 'icomoon-react'
import classNames from 'classnames'
import { logoutUser } from 'src/utils/helpers/GeneralHelpers'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import variables from 'src/assets/styles/variables.module.scss'
import iconSet from 'src/assets/icons/rebrandIconList.json'
import navStyles from '../navigation.module.scss'

const LinkComponent = ({ isMobile, tab }) => {
  if (!tab.show) return <></>

  return (
    <button className={navStyles.navItemContainer} onClick={tab.onClick}>
      <div className={isMobile && navStyles.navItemContainerWrapMobile}>
        <IcomoonReact
          iconSet={iconSet}
          color={variables.c01lightBase0000d3}
          size={21}
          icon={tab.icon}
        />
      </div>
      <span
        className={classNames(fontStyles.buttongraphik16pt, generalStyles.ml16)}
      >
        {tab.label}
      </span>
    </button>
  )
}

const FooterLinkComponent = ({ link }) => {
  return (
    <span className={fontStyles.pxsmallboldlsssin01lightbasegraphik12pt}>
      {link.href
        ? (
          <a
            href={link.href}
            target="_blank"
            rel="noreferrer"
            className={navStyles.customLink}
          >
            {link.label}
          </a>
        )
        : (
          <>{link.label}</>
        )
      }
    </span>
  )
}

const ProfileMenu = ({ setProfileMenuOpen, isMobile }) => {
  const navigate = useNavigate()

  const handleLogout = useCallback(() => {
    logoutUser()
    navigate('/auth/signin')
  }, [])

  const handleClick = useCallback((link) => {
    setProfileMenuOpen(false)
    navigate(link)
  }, [])

  const Tabs = useMemo(() => {
    return [
      {
        show: true,
        isActive: false,
        label: 'Edit Profile',
        icon: 'Controls-Edit',
        onClick: () => handleClick('/profile')
      },
      {
        show: false,
        label: 'Bookmarked',
        icon: 'Symbol-BookmarkIcon-BlueOutline',
        onClick: () => handleClick('/bookmarked')
      },
      {
        show: false,
        label: 'Settings',
        icon: 'Symbol-SettingsIcon-Large-BlueOutline',
        onClick: () => handleClick('/settings')
      },
      {
        show: true,
        label: 'Help & Support',
        icon: 'Help-03',
        onClick: () => handleClick('/contact')
      },
      {
        show: true,
        label: 'Logout',
        icon: 'Controls-LogOut',
        onClick: () => handleLogout()
      }
    ]
  }, [navigate, setProfileMenuOpen, handleLogout])

  const links = [
    {
      label: 'Terms & Conditions',
      href: 'https://www.evanta.com/terms/terms-and-conditions'
    },
    {
      label: 'Privacy Policy',
      href: 'https://www.evanta.com/terms/privacy-policy'
    },
    {
      label: 'Official Sweepstakes Rules ',
      href: 'https://www.evanta.com/terms/sweepstakes-rules'
    },
    {
      label: 'Official Leaderboard Rules',
      href: 'https://www.evanta.com/terms/leaderboard-rules'
    }
  ]

  if (isMobile) {
    return (
      <div>
        <div className={navStyles.profileMenuContainerMobile}>
          {Tabs.map((tab, index) => (
            <LinkComponent isMobile key={`${tab.label} - ${index}`} tab={tab} />
          ))}
        </div>
        <div className={navStyles.line} />
        <div className={navStyles.footerMenuContainerMobile}>
          {links.map((link, index) => (
            <FooterLinkComponent key={`${link.label} - ${index}`} link={link} />
          ))}
        </div>
      </div>
    )
  }

  return (
    <div
      className={navStyles.profileMenuContainer}
      onMouseLeave={() => setProfileMenuOpen(false)}
    >
      <div className={navStyles.leftContainer}>
        {Tabs.map((tab, index) => (
          <LinkComponent key={`${tab.label} - ${index}`} tab={tab} />
        ))}
      </div>
      <div className={navStyles.line} />
      <div className={navStyles.rightContainer}>
        {links.map((link, index) => (
          <FooterLinkComponent key={`${link.label} - ${index}`} link={link} />
        ))}
      </div>
    </div>
  )
}

export default ProfileMenu
